import logo from "../../assets/images/beautytreasure/logo.png";
const Footer = () => {
  return (
    <footer id="footer" className="py-10 md:py-20  bg-[#E8E8E8] text-xs">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5  max-w-6xl mx-auto px-8">
        <div className="col-span-1  space-y-5 flex items-center justify-start lg:justify-center">
          <div className="max-w-[150px]">
            <img
              src={logo}
              alt="beauty treasure  logo "
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="space-y-5 col-span-1 ">
          <h6 className="text-xl font-bold uppercase">Yangon Address</h6>
          <ul className="space-y-2 list-disc ">
            <li> Myanmar Plaza (2th Floor)</li>
            <li>Time City Time Mall (မြေညီထပ်)</li>
            <li>City Mall (မြေညီထပ်)</li>
            <li>Ak Concept (Junction Square 2th Floor)</li>
            <li>6.5miles Market Place (Ground Floor)</li>
            <li>M Tower (1st Floor)</li>
          </ul>
        </div>
        <div className="space-y-5 col-span-1">
          <h6 className="text-xl font-bold uppercase">Mandalay Address</h6>
          <ul className="space-y-2 list-disc ">
            <li>
              27st,73*74bet Beauty Treasures Mandalay Boutique & Distribution
            </li>
            <li>
              80st,27*28bet Capital Mall Mandalay 2nd floor Beauty Treasures
              Boutique
            </li>
            <li>
              19st,65*66bet City Mart 2nd floor No.203 Beauty Treasures Boutique
            </li>
          </ul>
        </div>
        <div className=" space-y-5 col-span-1 ">
          <h6 className="text-xl font-bold uppercase">Website</h6>
          <ul className="space-y-2 list-disc ">
            <li>
              <a
                href="https://beautytreasuresdistribution.com/"
                className="underline"
                // target="__blank"
              >
                Beauty Treasure
              </a>
            </li>
            <li>
              <a
                href="https://filorga.pitiplus.app/"
                className="underline"
                // target="__blank"
              >
                Filorga
              </a>
            </li>

            <li>
              <a
                href="https://uriage.pitiplus.app/"
                className="underline"
                // target="__blank"
              >
                Uriage
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
